import { useTranslation } from 'react-i18next';

export default function MaterialUpdates() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/60">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          {String(t('materials.updates.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('materials.updates.title')}
          </h2>
          {String(t('materials.updates.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="flex flex-col md:flex-row gap-10 items-start">
          <div className="flex-1">
            {String(t('materials.updates.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-700 tracking-[0.04em] leading-relaxed">{__s}</p>))}
            <div className="mt-6 flex items-start gap-3 p-4 border-l-2 border-accent-400/40 bg-background-50">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-accent-500 text-sm"></i>
              </div>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {t('materials.updates.inlineNote')}{' '}
                <a href="/blog" className="text-accent-500 hover:text-accent-400 underline underline-offset-2 transition-colors">
                  {t('materials.updates.inlineNoteLink')}
                </a>
                {t('materials.updates.inlineNoteSuffix')}
              </p>
            </div>
          </div>

          <div className="flex-shrink-0 w-full md:w-[280px]">
            <img
              src="/images/generated/materials-update-2026.jpg"
              alt={t('materials.updates.imgAlt')}
              className="w-full aspect-[4/3] object-cover object-top"
            />
            {String(t('materials.updates.imgCaption')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-400 tracking-[0.03em] mt-2 text-center">{__s}</p>))}
          </div>
        </div>
      </div>
    </section>
  );
}
